import sha256 from 'crypto-js/sha256'

export function getSha256(str: string): string {
  return sha256(str).toString()
}
